import { http } from '@pendo/http';

// APP-51518: added subId as an optinal parameter in order to pass the correct subscription id to the function so that when you are on a subs details and check the Salesforce Sandbox box it affects the sub you are viewing and not the overall main sub aka pendo-internal
export function getSalesforceIntegration (subId) {
    return http.get(`/api/s/${subId || '_SID_'}/integration/salesforce`);
}

export function getOAuthInformation () {
    return http.get('/api/s/_SID_/integration/salesforce/data');
}

export function getSalesforceSchemaObjects () {
    return http.get('/api/s/_SID_/integration/salesforce/tables');
}

export function getSalesforceSchemaObjectDetails (table) {
    return http.get(`/api/s/_SID_/integration/salesforce/schema/${table}`);
}

export function saveSalesforceJoinKeys (joinKeys) {
    return http.put('/api/s/_SID_/integration/salesforce/data', joinKeys);
}

export function addSalesforceToSubscription (kind) {
    return http.post('/api/s/_SID_/integration/salesforce', { addingFor: kind });
}

export function saveSalesforceMapping (level, mapping, key) {
    return http.put(`/api/s/_SID_/metadata/${level}/salesforce/schema/${key}`, mapping);
}

export function deleteSalesforceIntegration () {
    return http.delete('/api/s/_SID_/integration/salesforce');
}

// APP-51518: added subId as an optinal parameter in order to pass the correct subscription id to the function so that when you are on a subs details and check the Salesforce Sandbox box it affects the sub you are viewing and not the overall main sub aka pendo-internal
export function setSalesforceSandboxEnabled (value, subId) {
    return http.put(`/api/s/${subId || '_SID_'}/integration/salesforce/customuri`, {
        customUri: value,
    });
}
